angular.module('salesPath2')
    .config(['$stateProvider', function myAppConfig($stateProvider) {
        $stateProvider
            .state('search', {
                url: '/search',
                views: {
                    main: {
                        templateUrl: 'salesPath2Template/pages/search/search.tpl.html',
                        controller: 'searchCtrl'
                    },
                    'clientSearch@search': {
                        templateUrl: 'salesPath2Template/pages/clientSearch/clientSearch.tpl.html',
                        controller: 'clientSearchCtrl'
                    },
                    'clientAndVehicleSearch@search': {
                        templateUrl: 'salesPath2Template/pages/clientAndVehicleSearch/clientAndVehicleSearch.tpl.html',
                        controller: 'clientAndVehicleSearchCtrl'
                    }
                },
                resolve: {
                    redirectTo: ['$timeout', '$state', 'CONFIG', 'CONSTANTS', function($timeout, $state, CONFIG, CONSTANTS) {
                        if (CONFIG.BEHAVIOR.shortPath !== true) {
                            $timeout(function() {
                                $state.go(CONSTANTS.PAGE_START_CLIENT_SEARCH);
                            });
                           
                        }
                    }]
                }
            });
    }]);